import "./Documents.scss"
import PageLayout from "../../components/PageLayout/PageLayout";
import Icon, {documentIcon, plusIcon} from "../../components/Icon/Icon";
import {useEffect, useState} from "react";
import DocumentActions from "../../api/DocumentActions";
import DocumentCard from "./DocumentCard";
import Button from "../../components/Button/Button";
import DocumentModal from "./DocumentModal";
import {useNotification} from "../../hooks/useNotification";
import DeleteModal from "../../components/DeleteModal/DeleteModal";

const Documents = () => {
    const [modal, setModal] = useState(null);
    const [deleteModal, setDeleteModal] = useState(null);
    const [documents, setDocuments] = useState([]);
    const {triggerNotification} = useNotification();

    useEffect(() => {
        DocumentActions.getAll(setDocuments)
    }, [])

    return(
        <PageLayout
            icon={documentIcon}
            titlePage="Documents"
            className="documents-page"
        >
            <div className="documents-list">
                {
                    documents.map((document, index) =>
                        <DocumentCard
                            key={index}
                            document={document}
                            onEdit={document => setModal(document)}
                            onDelete={document => setDeleteModal(document)}
                        />
                    )
                }

                <Button className="new-document" onClick={() => setModal({})}>
                    <Icon svg={plusIcon}/>
                    Add new
                </Button>
            </div>

            {
                modal &&
                <DocumentModal
                    document={modal}
                    onClose={() => setModal(null)}
                    onSubmit={values => {
                       DocumentActions.save(values, res => {
                           if(values.id){
                               setDocuments(prev => prev.map(doc => doc.id === modal.id ? res : doc));
                               triggerNotification("Document updated successfully");
                           }else{
                               setDocuments(prev => [...prev, res]);
                               triggerNotification("Document created successfully");
                           }
                           setModal(null)
                        })
                    }}
                />
            }

            {
                deleteModal &&
                <DeleteModal
                    onClose={() => setDeleteModal(null)}
                    onConfirm={() => {
                        DocumentActions.remove(deleteModal.id, res => {
                            setDocuments(prev => prev.filter(doc => doc.id !== deleteModal.id));
                            triggerNotification("Document deleted successfully");
                            setDeleteModal(null);
                        })
                    }}
                    title="Deleting client"
                    message={`Are you sure you want to delete client "${deleteModal?.name}"?`}
                />
            }
        </PageLayout>
    )
}

export default Documents;